import { Button, Spinner } from "flowbite-react";

export default function PropertyMediaUploadPanel({
  children,
  fileButtonLabel = "Selecionar imagens do PC",
  helperText,
  onFileInputChange,
  onUpload,
  pasteBoxRef,
  queueLength,
  saveButtonLabel,
  saving,
  title,
  uploadError,
  uploading,
  onSave,
}) {
  return (
    <div
      ref={pasteBoxRef}
      tabIndex={0}
      className="rounded-lg border border-dashed border-gray-300 dark:border-gray-700 p-4 bg-gray-50 dark:bg-gray-900/30"
    >
      <div className="text-sm font-medium text-gray-900 dark:text-white">
        {title}
      </div>
      <div className="text-xs text-gray-500 mt-1">{helperText}</div>

      {children}

      <div className="mt-3 flex items-center gap-2">
        <label className="inline-flex">
          <input
            type="file"
            accept="image/*"
            multiple
            className="hidden"
            onChange={onFileInputChange}
            disabled={uploading}
          />
          <Button color="info" as="span" disabled={uploading}>
            {fileButtonLabel}
          </Button>
        </label>

        <Button color="gray" onClick={onSave} disabled={saving}>
          {saving ? "Salvando..." : saveButtonLabel}
        </Button>

        <Button
          className="text-slate-800"
          onClick={onUpload}
          disabled={uploading || queueLength === 0}
        >
          {uploading ? (
            <span className="inline-flex items-center gap-2">
              <Spinner size="sm" /> Enviando...
            </span>
          ) : (
            `Enviar ${queueLength} imagem(ns)`
          )}
        </Button>
      </div>

      {uploadError && <div className="mt-3 text-sm text-red-600">{uploadError}</div>}
    </div>
  );
}
